import service from '../service.js'

export default {
  /**
   * 获取设备类别
   * @returns 
   */
  List: () => {
    return service({
      url: '/EquipmentSort/List',
      method: 'get',
    })
  }
}